import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import SpaLoader from "../../Components/Loaders/SpaLoader";
import { ShowSPA } from "../../API/SPAAPI";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import BannerHome from "../../new-components/banner-home/BannerHome";
import SpaServicesList from "../../Components/SpaServicesList";
import { trackCategoryViewed } from "../../utils/mixpanel";

function SpaCategoryServices() {
  const navigate = useNavigate();
  const params = useParams();
  const room_uuid = params.room_uuid;
  const spa_uuid = params.spa_uuid;
  const category_id = params.category_id;
  const lang = localStorage.getItem("lang");

  let spa;
  let images;
  let text;
  let category;
  let categoryServices;
  const { data, isLoading, error } = ShowSPA(room_uuid, spa_uuid, lang);

  if (!isLoading) {
    if (error) {
      if (error?.response.status === 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data.data.status === false) {
        navigate(`/${room_uuid}/qr-scan`);
      } else {
        spa = data.data.data.spa;
        images = spa?.header_images;
        category = spa.categories?.find(
          (item) => String(item.id) === String(category_id),
        );
        categoryServices = category?.services;
        text = category?.name || data.data.data.header_title;

        if (!category) {
          navigate(`/${room_uuid}/hotel-services/spa/${spa_uuid}`, {
            replace: true,
          });
        }
      }
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (!isLoading && !error && category) {
      trackCategoryViewed({
        category_id: category.id,
        category_name: category.name || "",
        category_type: "spa",
      });
    }
  }, [isLoading, category?.id]);

  return (
    <div className="food pb-2">
      <Title title={text} />
      <main className="home-main bg-white back-white pad-top-0">
        {isLoading ? (
          <SpaLoader />
        ) : (
          <>
            <BannerHome className={"px-2"} headerImages={images} />
            <SpaServicesList
              services={categoryServices}
              room_uuid={room_uuid}
              spa_uuid={spa_uuid}
              category_id={category_id}
              theme
            />
          </>
        )}
      </main>
      <NewFooter />
    </div>
  );
}
export default SpaCategoryServices;
